import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Stack, Divider, IconButton, FormGroup, FormControlLabel, Switch, Tooltip, } from '@mui/material';
import SbcCommon from './SbcCommon';
import MultiLangDialogAndSingleDisplayIpt from './MultiLangDialogAndSingleDisplayIpt';
import Iconify from '../../common/iconify/Iconify';
import { ICONIFY } from '../../../Constants/iconify';

// sidebar panel for dropdown
export default function SbcOptions({
    data,
    handleOptions,
    handleSwitchChange,
    handleMultiIptChange,
    handleDragOptions
}) {

    const onDragEnd = ({ source, destination }) => {
        handleDragOptions(source, destination)
    }

    return (
        <Stack direction={'column'} spacing={1} >
            <Divider>Others</Divider>
            {/* <FormGroup>
                <FormControlLabel
                    label="Options Node"
                    control={<Switch name='optionsNode' checked={data?.optionsNode ?? false} onChange={handleSwitchChange} />}
                    color='success'
                />
            </FormGroup> */}
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId={data?.id}>
                    {(provided) => {
                        return (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {data?.answerOptionList && data?.answerOptionList?.map((op, idx) =>
                                    <Draggable key={idx} draggableId={'' + idx} index={idx}>
                                        {(provided) => {
                                            return (
                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    <Stack direction={'row'} alignItems={'center'} gap={1} mt={1} mb={1}>
                                                        <Iconify icon={ICONIFY.drag} />
                                                        <MultiLangDialogAndSingleDisplayIpt
                                                            key={op?.key || idx}
                                                            item
                                                            optionIdx={idx}
                                                            keyName={'answerOptionList'}
                                                            itemKeyName={op?.key}
                                                            valueObj={op?.value}
                                                            handleMultiIptChange={handleMultiIptChange}
                                                            handleOptions={handleOptions}
                                                        />
                                                    </Stack>
                                                </div>
                                            )
                                        }}
                                    </Draggable>
                                )}
                            </div>
                        )
                    }}
                </Droppable>
            </DragDropContext>

            <Tooltip title="create option">
                <IconButton disableRipple color='success' onClick={handleOptions('c')}>+</IconButton>
            </Tooltip>
        </Stack>
    )
}
